/** @format */

import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@clarix/hooks';
import { cn } from '@clarix/ui';

/**
 * Fixed banner at the top of the viewport when the user has no usable
 * connection — the device is offline, OR it is on a network (wifi) that has no
 * internet. Auto-hides when connectivity is restored.
 */
export function OfflineBanner() {
  const { isOnline, reason } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      className={cn(
        'fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-2',
        'bg-red-600 text-white text-lg font-medium py-1.5 px-4',
        'animate-in slide-in-from-top duration-300',
      )}
    >
      <WifiOff className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />
      <span>
        {reason === 'no-internet'
          ? 'Connected to a network, but no internet access. Check your connection.'
          : 'You\'re offline. Check your internet connection.'}
      </span>
    </div>
  );
}
